export const setupSubmitFormLinks = root => {
  root.querySelectorAll('[data-submit-form]').forEach(link => {
    const submit = event => {
      const form = link.closest('form');
      if (!form) {
        return;
      }
      event.preventDefault();
      form.requestSubmit();
    };
    link.addEventListener('click', submit);
    link.addEventListener('keydown', event => {
      if (event.key === ' ') {
        submit(event);
      }
    });
  });
};
